import { FaSignOutAlt } from "react-icons/fa";
import { FaPenToSquare } from "react-icons/fa6";

// components

const ChatHeader = ({ onLogout, emptyChat, botIsLoading, addNewChat }) => {
  return (
    <div
      className="bg-primary text-white py-3 px-4 d-flex align-items-center justify-content-between"
      style={{
        height: "65px",
      }}
    >
      <div className="d-flex align-items-center">
        <FaPenToSquare
          onClick={emptyChat || botIsLoading ? undefined : addNewChat}
          style={{
            fontSize: "1.5rem",
            opacity: emptyChat || botIsLoading ? 0.5 : 1,
          }}
        />
      </div>
      <div className="d-flex align-items-center flex-grow-1 justify-content-center">
        <h3 className="mb-0 font-weight-bold text-center">
          consiness AuthPilot
        </h3>
      </div>
      <div className="d-flex align-items-center">
        <div
          style={{
            borderLeft: "1px solid white",
            height: "30px",
            marginRight: "15px",
            marginLeft: "15px",
          }}
        ></div>
        <FaSignOutAlt
          onClick={onLogout} // Funktion für das Ausloggen
          style={{ cursor: "pointer", fontSize: "1.5rem", marginTop: "5px" }}
        />
      </div>
    </div>
  );
};

export default ChatHeader;
